import { Component,OnInit } from '@angular/core';

/**
* @ignore - do not show in documentation
*/
@Component({
    selector:    'v-announcement',
    templateUrl: './v-announcement.component.haml',
    styleUrls:   ['./v-announcement.component.sass'],
    standalone:  false
})
export class VAnnouncementComponent implements OnInit {

    public infoVisible = false;

    constructor(){
    }
    ngOnInit(): void {
    }
}
